import { useLiveQuery } from 'dexie-react-hooks';
import { useNavigate } from '@tanstack/react-router';
import { Bell } from 'lucide-react';
import { db } from '../db/schema';

/**
 * Cloche du header : badge avec le compte des fiches en attente de
 * validation SMS différée (consentStatus = pending_offline). Click → bascule
 * sur la liste des fiches où la `PendingConsentAlert` détaille chaque cas.
 *
 * Cachée quand 0 lead en attente — pas de bruit visuel inutile.
 */
export function PendingConsentBell() {
  const navigate = useNavigate();

  const count = useLiveQuery(async () => {
    const rows = await db.leads
      .where('consentStatus')
      .equals('pending_offline')
      .toArray();
    return rows.filter((l) => !l.archived).length;
  }, []) ?? 0;

  if (count === 0) return null;

  return (
    <button
      type="button"
      onClick={() => void navigate({ to: '/leads' })}
      className="relative tap-target rounded-full p-1.5 text-warning hover:bg-warning/10 transition-colors"
      aria-label={`${count} fiche${count > 1 ? 's' : ''} en attente de validation SMS`}
      title={`${count} fiche${count > 1 ? 's' : ''} en attente de validation SMS`}
    >
      <Bell className="h-5 w-5" strokeWidth={2.2} />
      <span
        className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-warning text-white text-micro font-extrabold flex items-center justify-center tabular-nums"
        aria-hidden
      >
        {count > 9 ? '9+' : count}
      </span>
    </button>
  );
}
